import { render, staticRenderFns } from "./FlowBig.vue?vue&type=template&id=5b806e2c&"
import script from "./FlowBig.vue?vue&type=script&lang=js&"
export * from "./FlowBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports